import React from "react";
const handleMobileMenuToggle = (e) => {
  e.currentTarget.classList.toggle("active");
  const headerMenu = document.querySelector(".xb-header-menu");
  if (headerMenu) {
    headerMenu.classList.toggle("active");
  }
};
const cloneMobile2 = () =>{
  const mobileMenu2 = document.querySelectorAll(".clone .container .header-bar-mobile .xb-nav-mobile");
    if (mobileMenu2) {
      mobileMenu2.forEach(element => {
          element.addEventListener("click", handleMobileMenuToggle);  
      });

    }
}
const StickyHeader = () => {
  var scrollDirection = "";
  var lastScrollPosition = 0;
  let xbHeader = document.querySelectorAll(".xb-header")[0];
  // Clone and make header sticky if the element with class 'xb-header' exists

  let clonedHeader = "";
  if (xbHeader) {
    xbHeader.classList.add("original");
    clonedHeader = xbHeader.cloneNode(true);
    clonedHeader.classList.add("clone");
    // Add classes to the cloned header
    clonedHeader.classList.add("xb-header-area-sticky", "xb-sticky-stt");
    clonedHeader.classList.remove("original");

    // Insert the cloned header after the original header
    xbHeader.parentNode.insertBefore(clonedHeader, xbHeader.nextSibling);
    cloneMobile2();
  }

  // 	// Handle scroll events

  const positiononScroll = () => {
    var currentScrollPosition = window.scrollY;
    // 	    	// Determine scroll direction
    scrollDirection =
      currentScrollPosition < lastScrollPosition ? "up" : "down";
    lastScrollPosition = currentScrollPosition;

    // 		// Check if element with ID 'xb-header-area' has class 'is-sticky'
    if (
      document.getElementById("xb-header-area")?.classList.contains("is-sticky")
    ) {
      // 			// Add or remove classes based on scroll position for sticky header and mobile header
      if (lastScrollPosition > 100) {
        clonedHeader.classList.add("xb-header-fixed");
      } else {
        clonedHeader.classList.remove("xb-header-fixed");
      }

      // 			// Add or remove classes for sticky header based on scroll direction
      if (scrollDirection === "up" && lastScrollPosition > 100) {
        clonedHeader.classList.add("xb-header-fixed");
      } else {
        clonedHeader.classList.remove("xb-header-fixed");
      }
    }
  };
  window.addEventListener("scroll", positiononScroll);





};

export default StickyHeader;
